import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

interface DisplayTile {
  image: string;
  title: string;
  height: number;
}

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on the Display Network (mobile): a full-screen two-column
 * grid of hotel tiles, with the long headline in a bar pinned to the bottom.
 * The hotels are static placeholders; they are not template fields.
 */
@Component({
  selector: 'app-pmax-display-mobile-02',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './display-mobile-02.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-mobile-02.component.scss'
})
export class PmaxDisplayMobile02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Staggered columns; heights in rem. */
  readonly leftTiles: DisplayTile[] = [
    { image: HOTELS + 'lacroma.jpg', title: 'Valamar Lacroma Hotel', height: 8.25 },
    { image: HOTELS + 'parentino.jpg', title: 'Valamar Parentino Hotel', height: 5.75 },
    { image: HOTELS + 'villa-nicoletta.jpg', title: 'Valamar Villa Nicoletta', height: 8.25 },
    { image: HOTELS + 'pical.jpg', title: 'Valamar Pical Resort', height: 6 },
  ];

  readonly rightTiles: DisplayTile[] = [
    { image: HOTELS + 'san-marino.jpg', title: 'San Marino Hotel', height: 6.75 },
    { image: HOTELS + 'obertauern.jpg', title: 'Valamar Obertauern Hotel', height: 8.75 },
    { image: HOTELS + 'girandella.jpg', title: 'Girandella Family', height: 8.25 },
  ];

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }
}
